import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { StyledDialog } from "../../../../styled/dialog";
import { Box, Dialog, Typography } from "@mui/material";

const PendingMessageAlertDialog = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: "center", pt: 4, pb: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography variant="h6" fontWeight="bold">
            Mensajes pendientes
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", px: 4 }}>
        <Typography variant="body1" sx={{ mt: 2, mb: 4, color: "text.secondary" }}>
          El siniestro posee mensajes sin leer o pendientes de respuesta.
        </Typography>
        <StyledDialog.Actions sx={{ justifyContent: "center" }}>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
          >
            CERRAR
          </Button>
        </StyledDialog.Actions>
      </DialogContent>
    </Dialog>
  );
};

export default PendingMessageAlertDialog;
